import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Target, Compass, Sparkles } from 'lucide-react';

const About = () => {
  const values = [
    { icon: <Heart />, title: 'Compassion', description: 'We meet you where you are with empathy and understanding' },
    { icon: <Target />, title: 'Integrity', description: 'Honest, transparent care rooted in evidence and ethics' },
    { icon: <Compass />, title: 'Empowerment', description: 'Equipping you with knowledge and tools to thrive' },
    { icon: <Sparkles />, title: 'Science-Based', description: 'Clinical expertise informed by the latest research' }
  ];

  return (
    <div className="page-about">
      {/* Hero */}
      <section className="about-hero section-padding">
        <div className="container">
          <div className="about-hero-content">
            <h1 className="hero-large">Where women finally get answers.</h1>
            <p className="body-large">
              Glow Health was founded on a simple belief: women deserve healthcare that truly listens. 
              Too many women spend years feeling dismissed, searching for answers, and settling for "it's just stress" or "it's just aging."
            </p>
            <p className="body-large">
              We're here to change that story.
            </p>
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="section-padding bg-secondary">
        <div className="container">
          <div className="grid-two-column">
            <div>
              <h2 className="heading-1">Our Mission</h2>
              <p className="body-large">
                To improve women's health through personalized, comprehensive hormonal medicine,treating the whole woman, not just lab numbers.
              </p>
            </div>
            <div>
              <p className="body-regular">
                We believe that hormonal health is foundational to overall wellbeing. When hormones are balanced, women feel vibrant, energized, and fully themselves. Our approach combines advanced diagnostics, evidence-based treatments, and ongoing support to help women reclaim their vitality.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section-padding">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-1">Our Values</h2>
            <p className="body-large">The principles that guide everything we do</p>
          </div>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon">{value.icon}</div>
                <h3 className="heading-3">{value.title}</h3>
                <p className="body-regular">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Philosophy */}
      <section className="section-padding bg-secondary">
        <div className="container">
          <div className="philosophy-content">
            <h2 className="heading-1">Our Philosophy</h2>
            <div className="philosophy-text">
              <p className="body-large">
                We treat the whole woman, not just lab numbers. Your hormone levels tell part of the story, but we're interested in all of it,your energy, sleep, mood, relationships, stress, and quality of life.
              </p>
              <p className="body-regular">
                Every woman's hormone journey is unique. What works for one may not work for another. That's why we take time to understand your specific symptoms, health history, and goals before creating a personalized treatment plan.
              </p>
              <p className="body-regular">
                We combine the latest clinical research with decades of experience in women's health. Our approach is rooted in functional medicine principles,addressing root causes rather than masking symptoms.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-banner">
        <div className="container">
          <div className="cta-content">
            <h2 className="hero-medium">Ready to start your journey?</h2>
            <p className="body-large">Let's help you feel like yourself again.</p>
            <Link to="/intake">
              <button className="btn-primary">Schedule Your Consultation</button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;